import apiService from '@/utils/api-client'
import {formatQueryStringForObject} from '@/utils/format-query'
import {getReportPartsExample, getStartAddressCheckExample} from '@/pages/your-reports/model/report-example'
import config from '@/utils/appConfig'

export default {
  // eslint-disable-next-line no-unused-vars
  async purchaseReports({ commit }, { address, coin, reportPartName }) {
    try {
      const data = await apiService.post(`/reports/purchase/${address}`, {
        coin,
        reportPartName,
      })
      return data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // eslint-disable-next-line no-unused-vars
  async reloadReport({ commit }, { address, coin, token }) {
    try {
      const data = await apiService.post(`/reports/reload/${address}`, {
        coin,
        token,
      })
      return data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getReportParts({ commit }, { address, coin, token, exampleId, legacy, configParams = {} }) {
    if (exampleId) return getReportPartsExample({ exampleId, token })
    try {
      const timestamp = new Date().toISOString();
      return apiService.get(`reports/${address}`, {
        params: {coin, token, legacy, timestamp},
        ...configParams,
      })
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getEtherscanWalletRisk({ commit }, { address, coin, configParams = {} }) {
    try {
      const data = apiService.get(`v1/etherscan/wallet-risk`, {
        headers: {
          'X-API-Key': config.VUE_APP_ETHERSCAN_API_KEY,
        },
        params: { address, chain_id: coin },
        ...configParams,
      })

      return data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getStartAddressCheck({ commit }, { address, coin, token, exampleId, legacy, configParams = {} }) {
    if (exampleId) return getStartAddressCheckExample({ exampleId })
    try {
      const data = apiService.get(`/reports/info/${address}`, {
        params: { coin, token, legacy },
        disableErrorToast: true,
        ...configParams,
      })

      return data
    } catch (error) {
      console.error(error)
      throw error
    }
  },

  async getReportsHistoryList(
    // eslint-disable-next-line no-unused-vars
    { commit },
    { lazyParams: { pageSize, pageNumber, sort } },
  ) {
    try {
      const data = apiService.get(
        `/reports/purchased?${formatQueryStringForObject(sort, 'sort')}`,
        {
          params: { pageSize, pageNumber },
        },
      )
      return data
    } catch (error) {
      console.error(error)
    }
  },
}
